import { Typography } from "@mui/material";
import { useGetList } from "ra-core";
import * as React from "react";
import DashboardCard from "./DashboardCard";

export function NewOrdersNumberCard(props) {
  const { sx, rest, days = 7 } = props;

  const [filter, setFilter] = React.useState({});

  React.useEffect(() => {
    setFilter({
      "created_at.from": new Date(
        Date.now() - days * 24 * 60 * 60 * 1000
      ).toISOString(),
    });
  }, []);

  const { total } = useGetList("admin/orders", {
    pagination: { page: 1, perPage: 1 },
    sort: { field: "created_at", order: "DESC" },
    filter: filter,
  });

  return (
    <DashboardCard
      sx={{ ...sx }}
      {...rest}
      title="Number of Orders"
      subheader={`in the last ${days} days`}
    >
      <Typography variant="h4" fontWeight="black">
        {total}
      </Typography>
    </DashboardCard>
  );
}
